module directives {
    export module logistics {
        interface IConsignmentSLAMetricsScope extends ng.IScope {
            consignmentSLAMetricsData: interfaces.consignment.IConsignmentSLAMetricsData[];
            isLoading: boolean;
            LoadConsignmentSLAMetricsData();
            navigateToConsignmentListView(statusDescription: string, SLAStatus: number);
        }

        export class consignmentSLAMetricsDirective implements ng.IDirective {
            templateUrl = 'templates/modules/applicationmain/logistics/consignmentSLAMetricsView.html';
            scope = {
            }

            public consignmentSLAMetricsData: interfaces.consignment.IConsignmentSLAMetricsData[];

            constructor(
                private generalService: interfaces.applicationcore.IGeneralService,
                private $state: ng.ui.IStateService,
                private bsLoadingOverlayService,
                private consignmentService: interfaces.consignment.IConsignmentService,
            ) {
                   
            }

            link = ($scope: IConsignmentSLAMetricsScope, $element: ng.IAugmentedJQuery, $state) => {
                var filterList: interfaces.applicationcore.IKeyValue[] = [];
                var searchList: interfaces.applicationcore.IKeyValue[] = [];
                
                $scope.LoadConsignmentSLAMetricsData = () => {
                    $scope.isLoading = true;
                    return this.consignmentService.GetConsignmentSLAMetricsData().query({
                    }, (resultList) => {
                            $scope.consignmentSLAMetricsData = resultList;
                        $scope.isLoading = false;
                    }).$promise;
                }

                $scope.LoadConsignmentSLAMetricsData();       
                
                $scope.navigateToConsignmentListView = (statusDescription: string, SLAStatus: number ) => {
                    filterList.push({ key: "Status", value: statusDescription });
                    searchList.push({ key: "SLAStatus", value: SLAStatus })
                    this.$state.go("auth.ConsignmentExports", { FilterList: filterList, SearchList: searchList });
                }
            }

            static factory(): ng.IDirectiveFactory {
                const directive = (generalService, $state,
                    bsLoadingOverlayService, consignmentService) => new consignmentSLAMetricsDirective(generalService, $state, bsLoadingOverlayService,consignmentService);
                directive.$inject = ["generalService", "$state", "bsLoadingOverlayService","consignmentService"];

                return directive;
            }
        }

        angular.module("app").directive("gtsConsignmentSla", consignmentSLAMetricsDirective.factory());
    }
}